import { Component, signal, inject, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { AffaireService } from '../../../core/services/affaire.service';
import { Affaire } from '../../../core/models/models';

@Component({
  selector: 'app-affaire-list',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    FormsModule,
    MatPaginatorModule,
    MatSortModule,
    MatIconModule
  ],
  templateUrl: `./affaire-list.component.html`,
  styleUrls: [`./affaire-list.component.css`],
})
export class AffaireListComponent implements OnInit {
  constructor(private router: Router) {}
  affaireService = inject(AffaireService);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  affaires = signal<Affaire[]>([]);
  totalElements = signal(0);
  page = signal(0);
  size = signal(10);
  searchQuery = '';
  sortField = 'createdAt';
  sortDirection = 'desc';
  showArchived = signal(false);

  private searchSubject = new Subject<string>();

  ngOnInit() {
    this.loadAffaires();

    this.searchSubject.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(query => {
      this.searchQuery = query;
      this.page.set(0);
      this.loadAffaires();
    });
  }

  loadAffaires() {
    const sortParam = `${this.sortField},${this.sortDirection}`;
    this.affaireService.getAffaires(this.searchQuery, this.page(), this.size(), sortParam, this.showArchived())
      .subscribe({
        next: response => {
          this.affaires.set(response.content);
          this.totalElements.set(response.totalElements);
        }
      });
  }

  onSearchChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.searchSubject.next(value);
  }

  onSortChange(sortState: Sort) {
    this.sortField = sortState.active;
    this.sortDirection = sortState.direction || 'asc';
    this.page.set(0);
    this.loadAffaires();
  }

  onToggleArchived() {
    this.showArchived.update(v => !v);
    this.page.set(0);
    this.loadAffaires();
  }

  onPageChange(event: PageEvent) {
    this.page.set(event.pageIndex);
    this.size.set(event.pageSize);
    this.loadAffaires();
  }

  onEdit(affaire: Affaire) {
    this.router.navigate(['/affaires/edit', affaire.id]);
  }
}
